<template>
  <div class="sectionTitle">
     <slot />
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped>

.sectionTitle {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #303c6c;
  height: 20vh;
}

@media (max-width: 1400px) {
  .sectionTitle {
    height: 15vh;
  }
}

@media (max-width: 500px) {
  .sectionTitle {
    height: 12vh;
  }
}

@media (max-height: 600px) {
  .sectionTitle {
    height: 30vh;
  }
}
</style>